import React, { useContext } from 'react';
import { DropdownContext } from './DropdownContext.es.js';
import styled from '../../../libs/styled.es.js';
import { Popper } from '../Popper/Popper.es.js';

const StyledDiv = styled.div(({ show, origin }) => `
    background-color: transparent;
    // transition: transform 0.2s, opacity 0.2s;
    // transform: scale(${show ? 1 : 0});
    // transform-origin: ${origin};
    opacity: ${show ? 1 : 0};
  `);
const StyledPopper = styled(Popper)(({ show }) => `
    visibility: ${show ? "visible" : "hidden"};
    z-index: 999;
  `);
const DropdownMenu = ({
  children,
  popperConfig,
  placement = "bottom-start",
  origin = "center top",
  className
}) => {
  const {
    state: { isOpen, referenceElement }
  } = useContext(DropdownContext);
  return /* @__PURE__ */ React.createElement(StyledPopper, {
    className,
    referenceElement,
    popperConfig,
    placement,
    show: isOpen
  }, /* @__PURE__ */ React.createElement(StyledDiv, {
    show: isOpen,
    origin
  }, children));
};

export { DropdownMenu };
